import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import TodayIcon from '@material-ui/icons/Today';
import UpdateIcon from '@material-ui/icons/Update';

import * as pages from 'common_constants/Pages';
import NavigationService from 'support/navigation/NavigationService';

import InvestorsImg from 'img/imgs/investors.svg';

import CommonDialog from 'components_newui/dialogs/CommonDialog';
import SingleInputForm from '../SingleInputForm';

import {
  formatDate,
  getCardColor,
} from '../utilsTemplate';

const TemplateCard = ({
  classes,
  templateItemData,
  myEmail,
  getCloneIdeaTemplateFn,
}) => {
  const [openClone, setOpenClone] = useState(false);

  const {
    id,
    templateName,
    createdBy,
    created,
    updated,
  } = templateItemData;

  const cardColor = getCardColor(id);

  const ROUTES = NavigationService.getRoutes();

  const updatePath =
    ROUTES[pages.UPDATEIDEATEMPLATE].pathWithOutID;

  return (
    <>
      <div className={classes.scorecardItem}>
        <div
          className={classes.cardTopBorder}
          style={{
            background: cardColor,
          }}
        />

        <div className={classes.cardHeader}>
          <h3 className={classes.scorecardName}>
            {templateName}
          </h3>

          <div className={classes.actionWrap}>
            <button
              type="button"
              onClick={() => setOpenClone(true)}
              className={`${classes.btns} ${classes.cloneBtn}`}
            >
              <FileCopyOutlinedIcon
                fontSize="small"
              />
              Clone
            </button>

            <Link
              to={{
                pathname: `${updatePath}/${id}`,
                state: templateItemData,
              }}
              className={`${classes.btns} ${classes.editBtn}`}
              style={{
                background: cardColor,
                borderColor: cardColor,
              }}
            >
              <EditOutlinedIcon
                fontSize="small"
              />
              Edit
            </Link>
          </div>
        </div>

        <div className={classes.divider} />

        <div className={classes.avtarContent}>
          <div className={classes.imgblock}>
            <img
              src={InvestorsImg}
              alt="avatar"
              className={classes.noimg}
            />
          </div>

          <div className={classes.avtarDetails}>
            <div className={classes.ownerName}>
              {createdBy}
            </div>

            <div className={classes.dateRow}>
              <span className={classes.dateText}>
                <TodayIcon
                  fontSize="small"
                />
                {formatDate(created)}
              </span>

              <span className={classes.dateText}>
                <UpdateIcon
                  fontSize="small"
                />
                {formatDate(updated)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <CommonDialog
        open={openClone}
        title="Clone Idea Template"
        cancelText="Close"
        hideSubmitBtn
        onClose={() =>
          setOpenClone(false)
        }
        content={
          <SingleInputForm
            getCloneIdeaTemplateFn={
              getCloneIdeaTemplateFn
            }
            myEmail={myEmail}
            currentTemplateIdPickUp={id}
            onSuccess={() =>
              setOpenClone(false)
            }
          />
        }
      />
    </>
  );
};

export default TemplateCard;